export const BookABusData = {
  offer: 'Exciting offers',
  perf: 'Ontime performance',
  point: 'Point to Point',
  ctaText: 'BOOK A BUS'
};
